module.exports = __webpack_public_path__ + "img/jumbopackh2h-inactive.a559abe0.svg";